export type ComboSourceBatch = {
  id?: number | string;
};

export function comboLoteLabel(index: number): string {
  return `Lote ${index + 1}`;
}

export function comboBatchKey(
  batch: ComboSourceBatch,
  index: number,
): string {
  return batch.id != null && batch.id !== "" ? `id:${batch.id}` : `idx:${index}`;
}

export function findBatchIndexByKey<T extends ComboSourceBatch>(
  batches: T[],
  key: string,
): number {
  if (key.startsWith("id:")) {
    const id = Number(key.slice(3));
    return batches.findIndex((batch) => Number(batch.id) === id);
  }
  if (key.startsWith("idx:")) {
    const index = Number(key.slice(4));
    return Number.isInteger(index) ? index : -1;
  }
  return -1;
}
